export const APP_NAMESPACE = 'PRE-FIBER/APP';
export const AVC_NAMESPACE = 'PRE-FIBER/AVC';
